const TrashCartPopUpIcon = (props) => (
  <svg
    width={18}
    height={17}
    viewBox='0 0 18 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.5848 4.98507C15.5707 4.98507 15.5495 4.98507 15.5284 4.98507C11.7966 4.64594 8.07197 4.51796 4.38257 4.8571L2.9435 4.98507C2.64722 5.01067 2.38621 4.8187 2.35799 4.54995C2.32978 4.2812 2.5414 4.05084 2.83063 4.02525L4.26971 3.89727C8.02259 3.55174 11.8249 3.68611 15.6342 4.02525C15.9234 4.05084 16.135 4.2876 16.1068 4.54995C16.0856 4.79951 15.8528 4.98507 15.5848 4.98507Z'
      fill='currentColor'
    />
    <path
      d='M6.76788 4.33879C6.73966 4.33879 6.71144 4.33879 6.67617 4.33239C6.394 4.2876 6.19648 4.03805 6.24586 3.7821L6.40105 2.94385C6.51392 2.32956 6.66912 1.47852 8.31277 1.47852H10.161C11.8117 1.47852 11.9669 2.36155 12.0727 2.95025L12.2279 3.7821C12.2773 4.04445 12.0798 4.294 11.7976 4.33239C11.5084 4.37719 11.2332 4.19802 11.1909 3.94207L11.0357 3.11022C10.937 2.55352 10.9158 2.44474 10.168 2.44474H8.31982C7.57207 2.44474 7.55796 2.53432 7.45214 3.10382L7.28989 3.93567C7.24757 4.17242 7.02183 4.33879 6.76788 4.33879Z'
      fill='currentColor'
    />
    <path
      d='M11.5001 15.2362H6.97126C4.50931 15.2362 4.41055 14.0012 4.33295 13.003L3.87442 6.55937C3.85326 6.29701 4.079 6.06666 4.36822 6.04746C4.6645 6.03466 4.9114 6.23303 4.93257 6.49538L5.3911 12.939C5.46869 13.9116 5.49691 14.2764 6.97126 14.2764H11.5001C12.9815 14.2764 13.0097 13.9116 13.0803 12.939L13.5388 6.49538C13.56 6.23303 13.8139 6.03466 14.1031 6.04746C14.3924 6.06666 14.6181 6.29062 14.5969 6.55937L14.1384 13.003C14.0608 14.0012 13.9621 15.2362 11.5001 15.2362Z'
      fill='currentColor'
    />
    <path
      d='M10.4074 11.7167H8.05837C7.76914 11.7167 7.5293 11.4991 7.5293 11.2367C7.5293 10.9744 7.76914 10.7568 8.05837 10.7568H10.4074C10.6967 10.7568 10.9365 10.9744 10.9365 11.2367C10.9365 11.4991 10.6967 11.7167 10.4074 11.7167Z'
      fill='currentColor'
    />
    <path
      d='M10.9996 9.15709H7.47243C7.18321 9.15709 6.94336 8.93953 6.94336 8.67718C6.94336 8.41483 7.18321 8.19727 7.47243 8.19727H10.9996C11.2888 8.19727 11.5286 8.41483 11.5286 8.67718C11.5286 8.93953 11.2888 9.15709 10.9996 9.15709Z'
      fill='currentColor'
    />
  </svg>
);
export default TrashCartPopUpIcon;
